<style lang="less" scoped>
  .title {
    font-size: 48px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.33;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }
  .button {
    margin-top: 24px;
  }
</style>

<template lang="pug">
  .time.std-layout
    .header
      header-component(@click-back='redirectBack')
    .content
      .title
        div 이미지
        div 타임어택
    .footer
      button-component.button(
        @click='$router.push({ name: `TimeNumber` })'
        :text='"숫자"'
        :icon='"/static/icons/icon-numbers@2x.png"')
      button-component.button(
        @click='$router.push({ name: `TimeCard` })'
        :text='"카드"'
        :icon='"/static/icons/icon-cards@2x.png"')
</template>

<script>
import HeaderComponent from '@/components/header/back';
import ButtonComponent from '@/components/button';

export default {
  methods: {
    redirectBack() {
      this.$router.go(-1);
    },
  },
  components: {
    HeaderComponent,
    ButtonComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/time/index.vue